import z from "zod";
import { DivisionStatus } from "./DivisionStatus";

export const frameContractUUIDSchema = z.uuid("Die ID sollte UUID sein");

export const providerSettingsSchema = z.object({
	jobrad: z
		.object({
			companyId: z.uuid("company id must be a valid UUID"),
			companyUrl: z.url("Invalid URL"),
			frameContractUUID: frameContractUUIDSchema,
		})
		.optional(),
});

export class AssetDivision {
	private constructor(
		readonly id: string,
		readonly status: DivisionStatus,
		readonly providerSettings: {
			readonly jobrad?: {
				readonly frameContractUUID: string;
				readonly companyId: string;
				readonly companyUrl: string;
			};
		}
	) {}

	private static schema = z.object({
		id: z.uuid("Invalid divisionId"),
		status: z.enum(Object.values(DivisionStatus)),
		providerSettings: providerSettingsSchema,
	});

	static fromJson(obj: any) {
		const validated = this.schema.parse(obj);
		return new AssetDivision(
			validated.id,
			validated.status,
			validated.providerSettings
		);
	}
}
